import { useEffect, useState } from "react"
import { nanoid } from "nanoid"

export function useUID() {
  const [id, setId] = useState(null)

  useEffect(() => {
    setId(`id-${nanoid()}`)
  }, [])

  return id
}
